import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  FormText,
  Button,
  Table,
} from "react-bootstrap";
import {
  IconUser,
  IconFileDescription,
  IconCalendarWeek,
  IconTrash,
  IconEdit,
} from "@tabler/icons-react";
import { toast } from "react-toastify";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, handleKeyDown } from "../../constant/_constant";
import DatePicker from "react-datepicker";
import { setContractName } from "../../redux/contrcatReducer";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import useDebounce from "../../hooks/useDebounce";
import { useParams } from "react-router-dom";
import OrderIdEditPopup from "./OrderIdEditPopup";
import { TreeSelect } from "primereact/treeselect";

function GeneralInfo({
  isEditing,
  onProjectIDBlur,
  order_ref_type,
  onOrderIDBlur,
  setCvEmails,
}) {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const [searchDebounces, setSearchDebounces] = useState({
    searchName: "",
  });

  const {
    data: fetchdata,
    isLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const { data: validIds, postData: fetchValidIDs } = usePostRequest(
    API_ENDPOINTS.GET_VALID_IDS,
  );
  const {
    data: fetchdatas,
    isLoadings,
    postData: fetchRfq,
  } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER_AUTOFILL);

  const { data: fetchProject, postData: fetchProjectData } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_VEHICLE,
  );

  const dispatch = useDispatch();
  const { order_id } = useParams();

  useEffect(() => {
    fetchContract();
    // fetchValidIDs();
  }, []);

  const {
    fields: customFields,
    append: appendField,
    remove: removeField,
  } = useFieldArray({
    control,
    name: "custom_fields",
  });

  // console.log("attachMENTS", watch("attachmentId"));

  const [fieldType, setFieldType] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [customFieldError, setCustomFieldError] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [showStatus, setshowStatus] = useState(false);

  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["super-admin"];
  const isSuperAdmin = user?.roles?.some((role) => allowedRoles.includes(role));
  const isDeptHead = user?.is_department_head;

  // Initial function with older functionality
  // const handleAddCustomField = () => {
  //   if (!fieldType || !fieldName.trim()) {
  //     setCustomFieldError("Both field type and name are required.");
  //     return;
  //   }

  //   appendField({
  //     type: fieldType,
  //     field_name: fieldName.trim(),
  //     value: "",
  //   });

  //   // Clear state
  //   setFieldName("");
  //   setFieldType("");
  //   setCustomFieldError("");
  // };

  // New function with dropdown changes
  // const handleAddCustomField = () => {
  //   if (!fieldType || !fieldName.trim()) {
  //     setCustomFieldError("Both field type and name are required.");
  //     return;
  //   }

  //   if (fieldType === "dropdown") {
  //     const { title, options } = parseDropdownField(fieldName);
  //     if (!title) {
  //       setCustomFieldError("Please enter a valid dropdown title.");
  //       return;
  //     }
  //     if (options.length === 0) {
  //       setCustomFieldError(
  //         'Please provide options after a semicolon, e.g. "Label; Option1, Option2"'
  //       );
  //       return;
  //     }
  //     console.log("optionsoptions", options)
  //     appendField({
  //       type: "dropdown",
  //       field_name: title,
  //       options: options,
  //       value: "",
  //     });
  //   } else {
  //     appendField({
  //       type: fieldType,
  //       field_name: fieldName.trim(),
  //       value: "",
  //     });
  //   }

  //   setFieldName("");
  //   setFieldType("");
  //   setCustomFieldError("");
  // };

  // Latest function with automatic creation of DHS optional field on DHS CV select
  const handleAddCustomField = () => {
    if (fieldType === "dhs") {
      const alreadyExists = customFields.some(
        (f) => f.field_name === "DHS Order Type",
      );

      if (alreadyExists) {
        setCustomFieldError("DHS Order Type already added.");
        return;
      }

      appendField({
        type: "dropdown",
        field_name: "DHS Order Type",
        options: ["Field", "Academy", "N/A"],
        value: "",
      });

      setFieldType("");
      setCustomFieldError("");
      return;
    }

    if (!fieldType || !fieldName.trim()) {
      setCustomFieldError("Both field type and name are required.");
      return;
    }

    if (fieldType === "dropdown") {
      const { title, options } = parseDropdownField(fieldName);

      if (!title) {
        setCustomFieldError("Please enter a valid dropdown title.");
        return;
      }

      if (options.length === 0) {
        setCustomFieldError(
          'Please provide options after a semicolon, e.g. "Label; Option1, Option2"',
        );
        return;
      }

      appendField({
        type: "dropdown",
        field_name: title,
        options: options,
        value: "",
      });
    } else {
      appendField({
        type: fieldType,
        field_name: fieldName.trim(),
        value: "",
      });
    }

    setFieldName("");
    setFieldType("");
    setCustomFieldError("");
  };

  const handleRemoveCustomField = (index) => {
    removeField(index);
  };

  const handleCancelCustomField = () => {
    setFieldType("");
    setFieldName("");
  };

  const opportunityTypeSelected = watch("opportunityType");

  const contractVehicleSelected = watch("contractVehicle");

  const dueDate = watch("dueDate");

  useEffect(() => {
    if (!opportunityTypeSelected) {
      setValue("opportunityType", "RFQ");
    }
  }, [setValue, opportunityTypeSelected]);

  // useEffect(() => {
  //   if (fetchdata?.data && !contractVehicleSelected && !isEditing) {
  //     setValue("contractVehicle", fetchdata.data[0]?.id);
  //   }

  //   if (fetchdata?.data) {
  //     const contractName = fetchdata.data.find(
  //       (vehicle) => vehicle.id == contractVehicleSelected,
  //     )?.name;
  //     if (contractName) {
  //       dispatch(setContractName(contractName));
  //     }
  //   }
  // }, [fetchdata, contractVehicleSelected, isEditing, setValue]);

  const [searchDebounce, setSearchDebounce] = useState();

  // console.log("setSearchDebounce", searchDebounce);
  const suppressAutoUpdate = useRef(false);
  const { debounceSearch } = useDebounce();
  const [showCreateOrder, setShowCreateOrder] = useState(false);
  const [suggestion, setSuggestion] = useState([]);
  const [suggestionData, setSuggestionData] = useState([]);

  const { postData: fetchProjectOpportunityData } = usePostRequest(
    API_ENDPOINTS.GET_VALID_IDS,
  );

  const suggestionBoxRef = useRef(null);

  useEffect(() => {
    if (contractVehicleSelected === "3" && !order_id) {
      const alreadyExists = customFields.some(
        (f) => f.field_name === "DHS Order Type",
      );

      if (!alreadyExists) {
        appendField({
          type: "dropdown",
          field_name: "DHS Order Type",
          options: ["Field", "Academy", "N/A"],
          value: "",
        });
      }
    }
  }, [contractVehicleSelected, order_id, customFields]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionBoxRef.current &&
        !suggestionBoxRef.current.contains(event.target)
      ) {
        setSuggestionData(null);
        setSearchDebounces({ searchName: "" });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchByProjectID = (e) => {
    setSearchDebounce({ search: e.target.value });
  };

  const onSuccessData = (data) => {
    setSuggestion(data);
    // console.log("the suggestions received are ", data);
  };

  useEffect(() => {
    if (searchDebounce?.search?.length >= 0) {
      fetchProjectOpportunityData(
        {
          search: searchDebounce.search,
        },
        onSuccessData,
      );
    }
  }, [debounceSearch, searchDebounce]);

  const handleSelect = (item) => {
    setValue("ProjectID", item?.rfq_id);
    setSuggestion([]);
    onProjectIDBlur?.(item?.rfq_id);
    setIsFocused(false);
  };

  const handleDropdownValue = (vehicleId) => {
    return vehicleId || "";
  };

  const handleFocus = () => {
    const se = watch("ProjectID");
    fetchProjectOpportunityData({ search: se }, onSuccessData);
    setIsFocused(true);
  };

  const handleBlur = () => {
    setTimeout(() => {
      setIsFocused(false);
    }, 150);
  };

  const CustomInput = ({ value, onClick }) => (
    <input
      className="form-control"
      type="text"
      value={value}
      placeholderText="Select a date"
      onClick={onClick}
      readOnly
      style={{ cursor: "pointer" }}
    />
  );

  const orderTypeSelected = watch("ordertype");

  useEffect(() => {
    if (!orderTypeSelected) {
      setValue("ordertype", "DS");
    }
  }, [setValue, orderTypeSelected]);

  const handleSearchByName = (e) => {
    setSearchDebounces({ searchName: e.target.value });
  };

  useEffect(() => {
    if (searchDebounces?.searchName?.length > 0) {
      fetchRfq(
        {
          first_name:
            searchDebounces?.searchName?.length > 0
              ? searchDebounces?.searchName
              : undefined,
          module_type: "ORDER",
        },
        onSuggestionSuccessData,
      );
    }
  }, [searchDebounces]);

  const onSuggestionSuccessData = (data) => {
    setSuggestionData(data);
  };

  const handleSelectOrganization = (item) => {
    suppressAutoUpdate.current = true;

    setValue("organization_name", item.display_name);

    setValue(
      "contractOfficerName",
      `${item?.first_name || ""} ${item?.last_name || ""}`,
    );
    setValue(
      "contractOfficerEmail",
      item?.primary_email ? item.primary_email.Address : "",
    );
    setValue(
      "contractOfficerPhone",
      item?.primary_phone ? item.primary_phone.FreeFormNumber : "",
    );
    setValue("contractOfficerAddress", item.address);

    setValue("shippingCustomerName", item?.shipping_name);
    setValue("shippingCustomerEmail", item?.shipping_email);
    setValue("shippingCustomerPhone", item?.shipping_phone);

    if (item?.shipping_address) {
      const address = item.shipping_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "") // Remove blank lines
        .join("\n");

      setValue("shippingCustomerAddress", formattedAddress);
    }

    setValue("BillingCustomerName", item?.billing_name);
    setValue("BillingCustomerEmail", item?.billing_email);
    setValue("BillingCustomerPhone", item?.billing_phone);

    if (item?.billing_address) {
      const address = item.billing_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "")
        .join("\n");
      setValue("BillingCustomerAddress", formattedAddress);
    }
    setSuggestionData(null);
  };

  // const onProjectDataSuccess = (data) => {
  //   setValue("ProjectID", "");
  //   setValue("organization_name", data?.data?.project?.organization_name || "");
  //   setValue("Order_Description", data?.data?.project?.brief || "");
  //   setValue("ordertype", data?.data?.project?.order_type || "");
  //   setValue(
  //     "order_Payment_Type",
  //     data?.data?.project?.order_payment_type || "",
  //   );

  //   setValue(
  //     "notifyEmails",
  //     data?.data?.project?.notify_emails === 1 ? "1" : "0",
  //   );
  //   setValue(
  //     "notifyEmailsVendor",
  //     data?.data?.project?.notify_emails_vendor === 1 ? "1" : "0",
  //   );

  //   setValue("custom_fields", data?.data?.project?.custom_fields || []);

  //   const emailsString = data?.data?.project?.team_emails;
  //   const emailsArray = emailsString ? emailsString.split(",") : [];
  //   setValue("notification_emails", emailsArray);

  //   const emailsStringOrderPending =
  //     data?.data?.project?.order_pending_notification_emails;
  //   const emailsArrayOrderPending = emailsStringOrderPending
  //     ? emailsStringOrderPending.split(",")
  //     : [];
  //   setValue("orderpending_notification_emails", emailsArrayOrderPending);
  //   const emailsStringOrderProgress =
  //     data?.data?.project?.order_progress_notification_emails;
  //   const emailsArrayOrderProgress = emailsStringOrderProgress
  //     ? emailsStringOrderProgress.split(",")
  //     : [];
  //   setValue("orderprogress_notification_emails", emailsArrayOrderProgress);

  //   setValue(
  //     "notifyEmails",
  //     data?.data?.project?.notify_emails === 1 ? "1" : "0",
  //   );
  //   setValue(
  //     "notifyEmailsVendor",
  //     data?.data?.project?.notify_emails_vendor === 1 ? "1" : "0",
  //   );

  //   setValue(
  //     "estimateddelivery",
  //     data?.data?.project?.estimated_delivery || "",
  //   );
  //   setValue("payment_terms", data?.data?.project?.payment_term || "");
  //   setValue("shipping_terms", data?.data?.project?.shipping_term || "");
  //   setValue(
  //     "payment_term_detail",
  //     data?.data?.project?.payment_term_detail || "",
  //   );
  //   setValue(
  //     "shipping_method_detail",
  //     data?.data?.project?.shipping_method_detail || "",
  //   );
  //   setValue("shipping_method", data?.data?.project?.shipping_method || "");
  //   setValue(
  //     "initial_consolidation",
  //     data?.data?.project?.initial_consolidation || "",
  //   );

  //   setValue("contractOfficerName", data?.data?.project?.rfqKo?.name || "");
  //   setValue("contractOfficerEmail", data?.data?.project?.rfqKo?.email || "");
  //   setValue("contractOfficerPhone", data?.data?.project?.rfqKo?.phone || "");
  //   setValue(
  //     "contractOfficerAddress",
  //     data?.data?.project?.rfqKo?.address || "",
  //   );
  //   setValue(
  //     "shippingCustomerName",
  //     data?.data?.project?.rfqShipping?.name || "",
  //   );
  //   setValue(
  //     "shippingCustomerEmail",
  //     data?.data?.project?.rfqShipping?.email || "",
  //   );
  //   setValue(
  //     "shippingCustomerPhone",
  //     data?.data?.project?.rfqShipping?.phone || "",
  //   );
  //   setValue(
  //     "shippingCustomerAddress",
  //     data?.data?.project?.rfqShipping?.address || "",
  //   );
  //   setValue(
  //     "BillingCustomerName",
  //     data?.data?.project?.rfqBilling?.name || "",
  //   );
  //   setValue(
  //     "BillingCustomerEmail",
  //     data?.data?.project?.rfqBilling?.email || "",
  //   );
  //   setValue(
  //     "BillingCustomerPhone",
  //     data?.data?.project?.rfqBilling?.phone || "",
  //   );
  //   setValue(
  //     "BillingCustomerAddress",
  //     data?.data?.project?.rfqBilling?.address || "",
  //   );

  //   setValue("contractVehicletype", data?.data?.contract_vehicle_type || "");
  // };



const onProjectDataSuccess = (data) => {

  const previousOrderType = watch("ordertype");
  const newOrderType = data?.data?.project?.order_type || "";

  setValue("ProjectID", "");
  setValue("organization_name", data?.data?.project?.organization_name || "");
  setValue("Order_Description", data?.data?.project?.brief || "");
  setValue("ordertype", newOrderType);

  // Toast: tab show hoga jab CV change se order type bhi change ho
  if (newOrderType && previousOrderType && newOrderType !== previousOrderType) {
    const orderTypeLabels = {
      DS: "Dropship",
      CRK: "Consolidate / Repack",
      M: "Manufacturing",
      KIT: "Kit",
      S: "Stock",
    };
    toast.success(
      `Selected Contract Vehicle updated your Order Type to the most common one – ${orderTypeLabels[newOrderType] || newOrderType}. If you did not intend changing that, please update the Order Type.`,
      { autoClose: 4000 }
    );
  }

  setValue("order_Payment_Type", data?.data?.project?.order_payment_type || "");
  setValue("notifyEmails", data?.data?.project?.notify_emails === 1 ? "1" : "0");
  setValue("notifyEmailsVendor", data?.data?.project?.notify_emails_vendor === 1 ? "1" : "0");
  setValue("custom_fields", data?.data?.project?.custom_fields || []);

  const emailsString = data?.data?.project?.team_emails;
  const emailsArray = emailsString ? emailsString.split(",") : [];
  setValue("notification_emails", emailsArray);

  const emailsStringOrderPending = data?.data?.project?.order_pending_notification_emails;
  const emailsArrayOrderPending = emailsStringOrderPending ? emailsStringOrderPending.split(",") : [];
  setValue("orderpending_notification_emails", emailsArrayOrderPending);

  const emailsStringOrderProgress = data?.data?.project?.order_progress_notification_emails;
  const emailsArrayOrderProgress = emailsStringOrderProgress ? emailsStringOrderProgress.split(",") : [];
  setValue("orderprogress_notification_emails", emailsArrayOrderProgress);

  setValue("estimateddelivery", data?.data?.project?.estimated_delivery || "");
  setValue("payment_terms", data?.data?.project?.payment_term || "");
  setValue("shipping_terms", data?.data?.project?.shipping_term || "");
  setValue("payment_term_detail", data?.data?.project?.payment_term_detail || "");
  setValue("shipping_method_detail", data?.data?.project?.shipping_method_detail || "");
  setValue("shipping_method", data?.data?.project?.shipping_method || "");
  setValue("initial_consolidation", data?.data?.project?.initial_consolidation || "");

  setValue("contractOfficerName", data?.data?.project?.rfqKo?.name || "");
  setValue("contractOfficerEmail", data?.data?.project?.rfqKo?.email || "");
  setValue("contractOfficerPhone", data?.data?.project?.rfqKo?.phone || "");
  setValue("contractOfficerAddress", data?.data?.project?.rfqKo?.address || "");
  setValue("shippingCustomerName", data?.data?.project?.rfqShipping?.name || "");
  setValue("shippingCustomerEmail", data?.data?.project?.rfqShipping?.email || "");
  setValue("shippingCustomerPhone", data?.data?.project?.rfqShipping?.phone || "");
  setValue("shippingCustomerAddress", data?.data?.project?.rfqShipping?.address || "");
  setValue("BillingCustomerName", data?.data?.project?.rfqBilling?.name || "");
  setValue("BillingCustomerEmail", data?.data?.project?.rfqBilling?.email || "");
  setValue("BillingCustomerPhone", data?.data?.project?.rfqBilling?.phone || "");
  setValue("BillingCustomerAddress", data?.data?.project?.rfqBilling?.address || "");
  setValue("contractVehicletype", data?.data?.contract_vehicle_type || "");
};

  const selectContractVehicle = (vehicleId) => {
    setValue("vehicleId", vehicleId);
    if (vehicleId && !isEditing) {
      fetchProjectData(
        {
          contract_type_id: vehicleId,
        },
        onProjectDataSuccess,
      );
    }
  };

  const openOrderPopup = () => {
    setShowCreateOrder(true);
  };

  const parseDropdownField = (input) => {
    const [titlePart, optionsPart] = input.split(";");
    const title = titlePart?.trim() || "";
    const options = optionsPart
      ? optionsPart
          .split(",")
          .map((o) => o.trim())
          .filter(Boolean)
      : [];
    return { title, options };
  };

  const contractVehicleNodes = (fetchdata?.data || []).map((vehicle) => ({
    key: String(vehicle.id),
    label: vehicle.name,
    selectable: true,
    children:
      vehicle.children?.map((child) => ({
        key: String(child.id),
        label: child.name,
        selectable: true,
        children: [], // extend to another level here if needed
      })) || [],
  }));

  const findVehicleById = (list, id) => {
  for (const v of list || []) {
    if (String(v.id) === String(id)) return v;
    const found = findVehicleById(v.children, id);
    if (found) return found;
  }
  return null;
};

  return (
    <>
      <OrderIdEditPopup
        show={showCreateOrder}
        onClose={() => setShowCreateOrder(false)}
        rfqId={order_id}
      />
      <Row className="">
        <Col lg={4} md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Order Type</Form.Label>
            <InputGroup>
              <Form.Select
                {...register("ordertype")}
                disabled={isEditing && !isSuperAdmin && !isDeptHead}
                // value={contractVehicleSelected}
                // onChange={(e) => setContractVehicleSelected(e.target.value)}
              >
                {/* <option value="">Select a type</option> */}
                <option value="DS">Dropship</option>
                <option value="CRK">Consolidate / Repack </option>
                <option value="M">Manufacturing</option>
                <option value="KIT">Kit</option>
                <option value="S">Stock</option>
              </Form.Select>
            </InputGroup>
            {errors.ordertype && (
              <span className="text-danger">{errors.ordertype.message}</span>
            )}
          </Form.Group>
        </Col>
        <input type="hidden" {...register("customerPaid")} />
        <Col lg={4} md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Order Payment Type</Form.Label>
            <InputGroup>
              <Form.Select {...register("order_Payment_Type")}>
                <option value="">Select a type</option>
                <option value="invoiced">Invoiced</option>
                <option value="pre-paid">Pre-Paid</option>
                <option value="post-paid">Post-Paid</option>
              </Form.Select>
            </InputGroup>
            {errors.order_Payment_Type && (
              <span className="text-danger">
                {errors.order_Payment_Type.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col lg={4} md={4} xs={6}>
          {/* <Form.Group className="mb-3">
            <Form.Label className="required">Order ID</Form.Label>
            <div className="d-flex align-items-center justify-content-between">
              <span
                className="trash_icon"
                onClick={() => openOrderPopup()}
              >
                <IconEdit size={20} stroke={1} />
              </span>
            </div>
            <Form.Control
              {...register("orderId")}
              // onBlur={(e) => {
              //   register("orderId").onBlur(e);
              //   onOrderIDBlur?.();
              // }}
              placeholder="Enter N/A"
              defaultValue={"N/A"}
              disabled={isEditing || order_ref_type === "project"}
            />
            {errors.orderId && (
              <span className="text-danger">{errors.orderId.message}</span>
            )}
          </Form.Group> */}
          <Form.Group className="mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <Form.Label className="required">Order ID</Form.Label>
              {}
              {(isSuperAdmin || isDeptHead) && order_id && (
                <span
                  className="trash_icon"
                  onClick={openOrderPopup}
                  style={{ cursor: "pointer" }}
                >
                  <IconEdit size={20} stroke={1} />
                </span>
              )}
            </div>

            <Form.Control
              {...register("orderId")}
              placeholder="Enter N/A"
              defaultValue={"N/A"}
              disabled={isEditing || order_ref_type === "project"}
            />
            {errors.orderId && (
              <span className="text-danger">{errors.orderId.message}</span>
            )}
          </Form.Group>
        </Col>
        {showStatus && (
          <>
            <Col lg={4} md={4} xs={6}>
              <Form.Group className="mb-3">
                <Form.Control
                  {...register("orderStatus")}
                  // type="hidden"
                  // onBlur={(e) => {
                  //   register("orderId").onBlur(e);
                  //   onOrderIDBlur?.();
                  // }}
                />
              </Form.Group>
            </Col>
            <Col lg={4} md={4} xs={6}>
              <Form.Group className="mb-3">
                <Form.Control
                  {...register("attachmentId")}
                  // type="hidden"
                  // onBlur={(e) => {
                  //   register("orderId").onBlur(e);
                  //   onOrderIDBlur?.();
                  // }}
                />
              </Form.Group>
            </Col>
          </>
        )}
      </Row>
      <Row>
        <Col lg={4} md={4} xs={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Contract Vehicle</Form.Label>
            <InputGroup>
              <TreeSelect
                value={
                  contractVehicleSelected
                    ? String(contractVehicleSelected)
                    : null
                }
                onChange={(e) => {
                  const selectedKey = e.value;
                  setValue("contractVehicle", selectedKey);
                  const selected = findVehicleById(fetchdata?.data, selectedKey);
                  setValue("cv_rfq_id", selected?.cv_rfq?.id ?? null);
                  selectContractVehicle(selectedKey);
                }}
                options={contractVehicleNodes}
                placeholder="Select a contract vehicle"
                filter
                filterPlaceholder="Search contract vehicle"
                disabled={isEditing && !isSuperAdmin && !isDeptHead}
                style={{ width: "100%" }}
              />
            </InputGroup>
            {errors.contractVehicle && (
              <span className="text-danger">
                {errors.contractVehicle.message}
              </span>
            )}
          </Form.Group>

          <input type="hidden" {...register("cv_rfq_id")} />
          {/* <Form.Group className="mb-3">
            <Form.Label className="required">Contract Vehicle</Form.Label>
            <InputGroup>
              <Form.Select
                {...register("contractVehicle")}
                disabled={isEditing}
                value={contractVehicleSelected || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setValue("contractVehicle", selectedValue);
                  selectContractVehicle(selectedValue);
                }}
              >
                <option>Select Contract Vehicle</option>
                {fetchdata?.data?.map((vehicle, index) => (
                  <option key={index} value={vehicle.id}>
                    {vehicle.name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            {errors.contractVehicle && (
              <span className="text-danger">
                {errors.contractVehicle.message}
              </span>
            )}
          </Form.Group> */}
        </Col>
        <Col lg={4} md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Opportunity ID</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                disabled={isEditing && !isSuperAdmin && !isDeptHead}
                {...register("ProjectID")}
                // onBlur={(e) => {
                //   register("ProjectID").onBlur(e);
                //   onProjectIDBlur?.();
                // }}
                placeholder="Opportunity ID"
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={(e) => handleSearchByProjectID(e)}
              />
            </InputGroup>
            {errors.ProjectID && (
              <span className="text-danger">{errors.ProjectID.message}</span>
            )}
          </Form.Group>

          {/* Suggestions Box */}
          {(isFocused || searchDebounce?.search?.length > 0) &&
            suggestion?.data?.length > 0 && (
              <div className="suggestions_box">
                <div className="table-responsive">
                  <Table>
                    <tbody>
                      {suggestion?.data?.map((item, index) => (
                        <tr
                          key={index}
                          onClick={() => handleSelect(item)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{item.rfq_id.toUpperCase()}</td>
                          <td>{item.brief || "No Description Available"}</td>
                          {/* <td>
                            {" "}
                            {item?.opportunity_type === "RFQ" || "RFP"
                              ? "OPPORTUNITY"
                              : item?.opportunity_type}
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
        </Col>
        <Col lg={4} md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Customer Name</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                {...register("organization_name")}
                placeholder="Enter Customer Name"
                onChange={handleSearchByName}
              />
            </InputGroup>
            <div>
              {suggestionData?.data?.length > 0 &&
                searchDebounces?.searchName?.length > 0 && (
                  <div className="suggestions_box" ref={suggestionBoxRef}>
                    <div className="table-responsive">
                      <Table>
                        <tbody>
                          {suggestionData?.data?.map((item, index) => (
                            <tr
                              key={index}
                              onClick={() => handleSelectOrganization(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <td>{item?.display_name}</td>
                              <td>{`${item?.first_name || ""}`}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                )}
            </div>
            {errors.organization_name && (
              <span className="text-danger">
                {errors.organization_name.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Form.Group className="mb-3">
            <Form.Label>Order Description</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                {...register("Order_Description")}
                placeholder="Enter Description"
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
              />
            </InputGroup>
            {errors.Order_Description && (
              <span className="text-danger">
                {errors.Order_Description.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row className="">
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Date Created</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="publishedDate"
                control={control}
                defaultValue={new Date()}
                rules={{ required: "Published date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value ? new Date(field.value) : new Date()}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    // minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control required"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                  />
                )}
              />
            </InputGroup>
            {errors.publishedDate && (
              <span className="text-danger">
                {errors.publishedDate.message}
              </span>
            )}
          </Form.Group>
        </Col>
        {orderTypeSelected !== "DS" ? (
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label className="">
                Estimated Date Shipped to Aspetto
              </Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconCalendarWeek stroke={1} />
                </InputGroup.Text>
                <Controller
                  name="actual_date"
                  control={control}
                  // rules={{ required: "Actual date is required" }}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      selected={field.value ? new Date(field.value) : null}
                      onChange={(date) => field.onChange(date)}
                      dateFormat="MM/dd/yyyy"
                      // minDate={new Date()}
                      placeholderText="Select Date"
                      className="form-control"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                      showYearDropdown
                      showMonthDropdown
                      customInput={<CustomInput />}
                    />
                  )}
                />
              </InputGroup>
              {errors.actual_date && (
                <span className="text-danger">
                  {errors.actual_date.message}
                </span>
              )}
            </Form.Group>
          </Col>
        ) : null}
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">
              {" "}
              Estimated Date Fulfilled
            </Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="estimated_date"
                control={control}
                rules={{ required: "Estimate date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    // minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown5
                    showMonthDropdown
                    customInput={<CustomInput />}
                  />
                )}
              />
            </InputGroup>
            {errors.estimated_date && (
              <span className="text-danger">
                {errors.estimated_date.message}
              </span>
            )}
          </Form.Group>
        </Col>
        {customFields.length > 0 &&
          customFields.map((field, index) => (
            <Col xs={4} key={index}>
              <Form.Group className="mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <Form.Label>{field.field_name}</Form.Label>
                  <span
                    className="trash_icon"
                    onClick={() => handleRemoveCustomField(index)}
                  >
                    <IconTrash size={20} stroke={1} />
                  </span>
                </div>
                {field.type === "number" && (
                  <Form.Control
                    type="text"
                    onKeyDown={handleKeyDown}
                    placeholder={`Enter ${field.field_name}`}
                    {...register(`custom_fields[${index}].value`)}
                  />
                )}
                {field.type === "text" && (
                  <Form.Control
                    type="text"
                    placeholder={`Enter ${field.field_name}`}
                    {...register(`custom_fields[${index}].value`)}
                  />
                )}
                {field.type === "date" && (
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCalendarWeek stroke={1} />
                    </InputGroup.Text>
                    <Controller
                      name={`custom_fields[${index}].value`}
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          selected={field.value ? new Date(field.value) : null}
                          onChange={(date) => field.onChange(date)}
                          dateFormat="MM/dd/yyyy"
                          // minDate={new Date()}
                          placeholderText={`Select ${
                            field.field_name || "Date"
                          }`}
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                        />
                      )}
                    />
                  </InputGroup>
                )}
                {field.type === "dropdown" && (
                  <Form.Select {...register(`custom_fields[${index}].value`)}>
                    <option value="">Select {field.field_name}</option>
                    {field.options?.map((opt, optIndex) => (
                      <option key={optIndex} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </Form.Select>
                )}
                {errors.custom_fields?.[index]?.value && (
                  <span className="text-danger">
                    {errors.custom_fields[index].value.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          ))}
      </Row>

      <Row>
        <Col lg={9} md={8}>
          <Form.Group className="mb-3">
            <Form.Label>Custom Fields</Form.Label>
            <InputGroup className="custom-dropdown mb-3">
              <DropdownButton
                variant="outline-secondary"
                title={fieldType || "Select Type"}
                id="input-group-dropdown-1"
                onSelect={(type) => setFieldType(type)}
              >
                <Dropdown.Item eventKey="number">Number</Dropdown.Item>
                <Dropdown.Item eventKey="text">Text</Dropdown.Item>
                <Dropdown.Item eventKey="date">Date</Dropdown.Item>
                <Dropdown.Item eventKey="dropdown">Dropdown</Dropdown.Item>
              </DropdownButton>
              <Form.Control
                aria-label="Field Name"
                value={fieldName}
                onChange={(e) => setFieldName(e.target.value)}
                // placeholder="Enter field name"
                placeholder={
                  fieldType === "dropdown"
                    ? 'e.g. "DHS Order Type; Field, Academy, N/A"'
                    : "Enter field name"
                }
              />
            </InputGroup>
          </Form.Group>
        </Col>

        <Col lg={3} md={4}>
          <Form.Label className="form-label d-none d-sm-block">
            &nbsp;
          </Form.Label>
          <div className="d-flex gap-2">
            <Button
              className="flex-grow-1"
              onClick={handleAddCustomField}
              variant="warning"
            >
              Add
            </Button>
            <Button
              className="flex-grow-1"
              variant="outline-secondary"
              onClick={handleCancelCustomField}
            >
              Cancel
            </Button>
          </div>
        </Col>
      </Row>
      {customFieldError && (
        <span className="text-danger mt-1">{customFieldError}</span>
      )}
    </>
  );
}

export default GeneralInfo;
